import { MQT12G, MQT13G } from 'constants/dash'
import {
  DASH_TYPE_Q_BUS_DATABOOK_CODE,
  DASH_42N_M2_SD,
} from 'components/SwitchAndGauge/definitions/dashConstants'
import { TRUCK_SUBTYPE_42N } from './constants'

/* 
  CHEC use last 3 digits of Switch part number from CHEC_SWITCH_INFO table to determine Cap part numbers.
  if Last 3 of SW_NO < 48 ... use MQT12G
  if Last 3 of SW_NO >= 48 ... use MQT13G

  Example of CAP part number is MQT12G0083
  All parts in CHEC_SWITCH_INFO that has SW_MDUL_BASE is a custom switch.
*/
export const getCAPPartPrefix = (partNumber) => {
  const strLength = partNumber.length
  const last3Digits = parseInt(partNumber.substring(strLength - 3, strLength))

  if (last3Digits < 48) {
    return MQT12G
  }

  return MQT13G
}

export const isDashTypeBus = (vehicleSubType, dashboardType, dataBookCodes) =>
  vehicleSubType === TRUCK_SUBTYPE_42N &&
  dashboardType === DASH_42N_M2_SD &&
  dataBookCodes.includes(DASH_TYPE_Q_BUS_DATABOOK_CODE)
